import React, { ReactElement } from "react";
import { COUPON_LISTING_SHIMMER_CONTAINER_TEST_ID } from "@core-ui/constants/Coupon";

import {
    ShimmerContainer,
    ShimmerTitle,
    ShimmerContainerWrapper,
    ShimmerRibbon,
    ShimmerRibbonCircles,
    ShimmerRibbonCircle,
    ShimmerContainerCard,
    ShimmerContainerCardRow1,
    ShimmerContainerCardRow1LogoAndTitle,
    ShimmerContainerCardRow1Col1,
    ShimmerContainerCardRow1Col2,
    ShimmerContainerCardRow1Col3,
    ShimmerContainerCardSeparator,
    ShimmerContainerCardRow2,
    ShimmerContainerCardRow3,
    ShimmerContainerCardRow4,
    ShimmerContainerCardRow5,
} from "./styles";

const CouponCardShimmer = (): ReactElement => {
    return (
        <ShimmerContainerWrapper>
            <ShimmerRibbon>
                <ShimmerRibbonCircles>
                    <ShimmerRibbonCircle />
                    <ShimmerRibbonCircle />
                    <ShimmerRibbonCircle />
                    <ShimmerRibbonCircle />
                </ShimmerRibbonCircles>
            </ShimmerRibbon>
            <ShimmerContainerCard>
                <ShimmerContainerCardRow1>
                    <ShimmerContainerCardRow1LogoAndTitle>
                        <ShimmerContainerCardRow1Col1 />
                        <ShimmerContainerCardRow1Col2 />
                    </ShimmerContainerCardRow1LogoAndTitle>
                    <ShimmerContainerCardRow1Col3 />
                </ShimmerContainerCardRow1>
                <ShimmerContainerCardRow2 />
                <ShimmerContainerCardSeparator />
                <ShimmerContainerCardRow3 />
                <ShimmerContainerCardRow4 />
                <ShimmerContainerCardRow5 />
            </ShimmerContainerCard>
        </ShimmerContainerWrapper>
    );
};

const CouponListingShimmer = (): ReactElement => {
    return (
        <ShimmerContainer data-testid={COUPON_LISTING_SHIMMER_CONTAINER_TEST_ID}>
            <ShimmerTitle />
            <CouponCardShimmer />
            <CouponCardShimmer />
            <CouponCardShimmer />
            <CouponCardShimmer />
        </ShimmerContainer>
    );
};

export default CouponListingShimmer;
